import React from "react";
import { type NextPage } from "next";
import { getLandingPageProps, getPageMetaImage, type LandingPageProps } from "utils";
import { Page } from "components/page";
import {
  WarehouseHero,
  WarehouseAsCdp,
  WarehouseCdpDiagram,
  WarehouseAccordion,
  WarehouseSecurityFeatures,
  WarehouseWordCloud,
  WarehouseUseCaseTabs,
  WarehouseFaq,
  WarehouseAidVideo,
} from "components/solutions/warehouses";
import { DataTeamsCards } from "components/platform-overview-content";
import { WarehouseCdpProvider, WarehouseCdpVariants } from "contexts/warehouse-cdp-context";
import { SolidPlate } from "ui/plates";
import { StackedLogos } from "components/logos";
import { sectionSpacingY } from "components/section";

const AzureSynapse: NextPage<LandingPageProps> = ({ page, announcementBanner, defaultLogos, defaultMobileLogos }) => {
  const warehouseConfig = WarehouseCdpVariants.azure;

  return (
    <Page
      title={page.metaTitle}
      description={page.metaDescription}
      image={getPageMetaImage({ src: page.metaImageUrl, alt: page.metaTitle })}
      announcementBanner={announcementBanner}
      bgColor={`new.${warehouseConfig.color}.150`}
      footerOptions={{ variant: warehouseConfig.color }}
    >
      <WarehouseCdpProvider warehouse={warehouseConfig}>
        <WarehouseHero titleMaxW={{ base: "3xl", xl: "55%" }} title={page.title} description={page.description} />
        <StackedLogos my="0" pt={sectionSpacingY} customers={defaultLogos} mobileCustomers={defaultMobileLogos} />
        <WarehouseAsCdp my="0" py={sectionSpacingY} />
        <SolidPlate
          theme="dark"
          bgColor={`new.${warehouseConfig.color}.950`}
          spotlightColor={`new.${warehouseConfig.color}.900`}
        >
          <WarehouseCdpDiagram theme="dark" />
          <WarehouseAccordion theme="dark" />
          <WarehouseSecurityFeatures theme="dark" bgColor={`new.${warehouseConfig.color}.950`} />
        </SolidPlate>
        <WarehouseAidVideo textMaxW="780px" />
        <WarehouseWordCloud />
        <DataTeamsCards warehouse={warehouseConfig} />
        <WarehouseUseCaseTabs />
        <WarehouseFaq />
      </WarehouseCdpProvider>
    </Page>
  );
};

export const getStaticProps = getLandingPageProps("/solutions/azure-synapse-cdp", {
  loadDefaultLogos: true,
  loadDefaultMobileLogos: true,
});

export default AzureSynapse;
